import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
import route from '../store/index'
import api from '../api/index'

Vue.use(VueRouter)
export const routes = [
  {
    path: '/',
    name:'Layout',
    component:() => import('../layout.vue'),
    redirect:{name:'list'},
    hidden: true,
    children:[
      {
        path:"/index",
        name:"index",
        component: () => import('../views/index/index.vue')
      },
      {
        path:"/blank",
        name:"blank",
        component: () => import('../views/index/blank.vue')
      },
      {
        path: '/instrumentsPanel/list',
        name: 'list',
        meta:{bread:[{name:"仪表盘",jump:''}]},
        component: () => import('../views/instrumentsPanel/list.vue')
    },
    {
        path: "/instrumentsPanel/marketList",
        name: "marketList",
        meta: {bread:[{name:"仪表盘",jump:''},{name:"电商/销售数据",jump:''}]},
        component: () => import('../views/instrumentsPanel/marketList.vue')
    },  {
      path: "/CntManagement/tformorders/tformorders",
      name: "tformorders",
      meta: {bread:[{name:"订单/评论管理",jump:''},{name:"平台订单列表",jump:''}]},
      component: () => import("../views/CntManagement/tformorders/tformorders.vue")
    },
    {
      path: "/CntManagement/ruralorders/ruralorders",
      name: "ruralorders",
      meta: {bread:[{name:"订单列表",jump:''}]},
      component: () => import("../views/CntManagement/ruralorders/ruralorders.vue")
    },
    {
      path: "/CntManagement/distribution/distribution",
      name: "distribution",
      // meta:{tabBar:true,auth:false},
      meta: {bread:[{name:"订单/评论管理",jump:''},{name:"分销记录",jump:''}]},
      component: () => import("../views/CntManagement/distribution/distribution.vue")
    },
    
    {
      path: "/CntManagement/commentmana/commentmana",
      name: "commentmana",
      // meta:{tabBar:true,auth:false},
      meta: {bread:[{name:"评价管理",jump:''}]},
      component: () => import("../views/CntManagement/commentmana/commentmana.vue")
    },
    {
      path: "/orderdetails",
      name: "orderdetails",
      meta: {bread:[{name:"订单/评论管理",jump:''},{name:"订单列表",jump:'back'},{name:"订单详情",jump:''}]},
      component: () => import("../views/CntManagement/orderdetails/orderdetails.vue")
    },
    {
      path: "/send",
      name: "send",
      meta: {bread:[{name:"订单/评论管理",jump:''},{name:"订单列表",jump:'back'},{name:"售后详情",jump:''}]},
      component: () => import("../views/CntManagement/send/send.vue")
    },
    {
      path: "/settings",
      name: "settings",
      meta: {bread:[{name:"系统设置",jump:''},{name:"客服设置",jump:''}]},
      component: () => import("../views/Setup/settings/settings.vue")
    },
    {
      path: "/accountMessage",
      name: "accountMessage",
      meta: {bread:[{name:"系统设置",jump:''},{name:"账号信息",jump:''}]},
      component: () => import("../views/Setup/accountMessage/accountMessage.vue")
    },
    {
      path: "/routeS",
      name: "routeS",
      meta: {bread:[{name:"设置",jump:''},{name:"路由管理",jump:''}]},
      component: () => import("../views/Setup/routeS/routeManagement.vue")
    },
{
  path: "/Banner",
  name: "Banner",
  meta: { bread:[{name:"内容信息管理",jump:''} , {name:"banner管理",jump:''}] },
  component: () => import("../views/mantiopl/Banner/Banner.vue")
},
{
  path: "/feedback",
  name: "feedback",
  meta: { bread:[{name:"内容信息管理",jump:''} , {name:"反馈建议",jump:''}] },
  component: () => import("../views/mantiopl/feedback/feedback.vue")
},
{
  path: "/mantiopl/Reporting/reporting",
  name: "Reporting",
  meta: { bread:[{name:"内容信息管理",jump:''} , {name:"举报信息",jump:''}] },
  component: () => import("../views/mantiopl/Reporting/reporting.vue")
},
{
  path: "/mantiopl/Phonebook/Phonebook",
  name: "Phonebook",
  meta: { bread:[{name:"内容信息管理",jump:''} , {name:"电话本设置",jump:''}] },
  component: () => import("../views/mantiopl/Phonebook/Phonebook.vue")
},
{
  path: "/Platform/managementF/managementF",
  name: "managementF",
  meta: {bread:[{name:"商品管理",jump:''},{name:"商品管理列表",jump:''}]},
  component: () => import("../views/Platform/managementF/managementF.vue")
},

{
  path: "/Platform/managementF/oductediti",
  name: "oductediti",
  // meta:{tabBar:true,auth:false},
  // meta: { bread:["平台电商管理","平台商品管理"] },
  component: () => import("../views/Platform/managementF/oductediti.vue")
},

{
  path: "/Platform/belmanag/belmanag",
  name: "belmanag",
  // meta:{tabBar:true,auth:false},
  meta: {bread:[{name:"平台电商管理",jump:''},{name:"标签管理",jump:''}]},
  component: () => import("../views/Platform/belmanag/belmanag.vue")
},

{
  path: "/Platform/logistics/logistics",
  name: "logistics",
  // meta:{tabBar:true,auth:false},
  meta: {bread:[{name:"商品管理",jump:''},{name:"地址设置",jump:''}]},
  component: () => import("../views/Platform/logistics/logistics.vue")
},
{
  path: "/myInformation",
  name: "myInformation",
  // meta:{tabBar:true,auth:false},
  meta: {bread:[{name:"我的账户/收益信息",jump:''}]},
  component: () => import("../views/myInformation/myInformation.vue")
},
{
  path: "/myInformation/myInformationReva",
  name: "myInformationReva",
  // meta:{tabBar:true,auth:false},
  meta: {bread:[{name:"我的账户/收益信息",jump:'myInformation'},{name:"提现账号编辑",jump:''}]},
  component: () => import("../views/myInformation/myInformationReva.vue")
},
{
  path: "/financeAdmin/distributionList",
  name: "withdrawList",
  // meta:{tabBar:true,auth:false},
  meta: {bread:[{name:"财务管理",jump:''},{name:"分销记录",jump:''}]},
  component: () => import("../views/financeAdmin/distributionList.vue")
},
{
  path: "/financeAdmin/waterBill",
  name: "waterBill",
  // meta:{tabBar:true,auth:false},
  meta: {bread:[{name:"财务管理",jump:''},{name:"流水账单记录",jump:''}]},
  component: () => import("../views/financeAdmin/waterBill.vue")
},
{
  path: "/OwnershipManagement",
  name: "OwnershipManagement",
  meta: {bread:[{name:"归属管理",jump:''}]},
  component: () => import('../views/OwnershipManagement/list.vue')
},
{
path: "/OwnershipManagement/recordsT",
name: "recordsT",
meta: {bread:[{name:"乡村电商服务",jump:''},{name:"归属管理",jump:'/OwnershipManagement'},{name:"收入/结算记录",jump:''}]},
component: () => import("../views/OwnershipManagement/recordsT.vue")
},
{
  path: "/OwnershipManagement/addRecords",
  name: "addRecords",
  meta: {bread:[{name:"乡村电商服务",jump:''},{name:"归属管理",jump:'/OwnershipManagement'},{name:"添加归属管理",jump:''}]},
  component: () => import("../views/OwnershipManagement/addRecords.vue")
  },
    ],
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../login.vue')
  },
  
]
const router = new VueRouter({
  routes
})
// 路由拦截
router.beforeEach((to,from,next) =>{
  // let arr = JSON.parse(localStorage.getItem('routeList'))
  // let routeID =localStorage.getItem('rouId')
  let page = to.path.split('/')
  let toPage = page[2] == 'productList'? '/production/productList' : to.path 
  let a = [true]
//   // if(arr) {
//   //   console.log(arr,'arr')
//   //   arr.forEach(e =>{
//   //     if(!e.childMenus) return
//       // a.push(e.childMenus.some(obj =>{

//         // 存在路由时存储按钮
//         // if(obj.jump === toPage) {
//           // api.account.adminJurisdiction().then(res => {
//           //   let data = res.data.data
//           //   data.forEach(child =>{
//           //     if(Number(child.id) === Number(routeID)) {
//           //       if(obj.childMenus) {
//           //         let childData = child.roule.split(',')
//           //         let control = []
//           //         obj.childMenus.forEach(son =>{
//           //           childData.forEach(sonCd =>{
//           //             if(Number(sonCd) === son.id) {
//           //               control.push(son.jump)
//           //             }
//           //           })
//           //         })
//           //         route.commit('savePageButton', control)
//           //       }
//           //     }
//           //   })
//           // })
//         // }
//         // return obj.jump === toPage
      // }
      // ))

//   //   })
//   // }
  // if(
  //     a.includes(true) || toPage === '/index' || 
  //     toPage === '/Login' || toPage === '/blank' || 
  //     toPage === '/production/productListDialog' || 
  //     toPage === '/orderManagement/productOrderDetail'
  //     )
  //   {
    next()
  // }
})
export default router




// WEBPACK FOOTER //
// ./src/router/index.js